export default {
  accountsPayableLink: (accountsPayableLinkId: string): string =>
    `/accounts-payable/${accountsPayableLinkId}/checkout`,
  updateAccountsPayableLinkStatus: '/accounts-payable/update/status',
  requestFunds: '/accounts-payable/request-funds',
};
